import React from "react";
import styles from '../CreateParameterPopup.module.css'
import { useTranslation } from "react-i18next";
import LabelParameters from "../LabelParameters";
  const Textbox = ({parameterData, handleChange,editingInput,setEditingInput}) => {
  const [t] = useTranslation("Contacts");

  return (
    <div>

      <LabelParameters value={parameterData.number} text={'textBox'} editingInput={editingInput} setEditingInput={setEditingInput} direction="column">
      <textarea
        name="textbox"
        value={parameterData.textbox}
        onChange={handleChange}
        placeholder={t("parameterValue")}
      />
</LabelParameters>
 
    </div>
  );
};

export default Textbox;
